module.exports = __webpack_public_path__ + "static/media/trophy-alt.241284bb.svg";